var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c(
        "button",
        {
          staticClass: "flex items-start focus:outline-none",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.modalShown = true
            },
            mouseover: function ($event) {
              _vm.isHovered = true
            },
            mouseout: function ($event) {
              _vm.isHovered = false
            },
          },
        },
        [
          !_vm.isHovered ? _c("TagIcon", { class: _vm.iconClass }) : _vm._e(),
          _vm.isHovered
            ? _c("TagIconHover", { class: _vm.iconClass })
            : _vm._e(),
        ],
        1
      ),
      _vm.tagShown
        ? _c("Badge", {
            staticClass: "ml-2",
            attrs: { value: _vm.appliedTag.name, color: _vm.BadgeColor.INFO },
          })
        : _vm._e(),
      _vm.modalShown
        ? _c("EmployeeTagModal", {
            attrs: {
              avatar: _vm.avatar,
              fullName: _vm.fullName,
              initials: _vm.initials,
              available: _vm.available,
              contractorId: _vm.contractorId,
              appliedTag: _vm.appliedTag,
              userUpdatedDate: _vm.userUpdatedDate,
            },
            on: {
              close: function ($event) {
                _vm.modalShown = false
              },
              tagUpdated: _vm.onUpdateTag,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }